import React from 'react';
import { connect } from 'react-redux'
import { setInfoKey } from '../../api/information-collection/actions'
import { addInsuranceTakerFromNationalRegistry } from '../../api/insurance-takers/actions'
import { fetchNationalRegistry } from '../../api/national-registry/actions'
import { formatKennitalaAsDate } from '../../utils';
import Alert from 'react-bootstrap/Alert'


const kennitala = require('kennitala')


class InsuranceTakerModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            search: ''
        }

        this.addInsuranceTaker = this.addInsuranceTaker.bind(this)
        this.isDisabled = this.isDisabled.bind(this)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.nationalRegistry.data.find(item => item.OrgId === prevState.search)) {
            return { payerObj: nextProps.nationalRegistry.data.find(item => item.OrgId === prevState.search) };
        }
        else return null;
    }

    componentDidMount(){
        initialInputState();
        let that = this;
        $('#' + this.props.id).on('hidden.bs.modal', function () {
            that.clearModal();
        });
    }

    componentDidUpdate(){
        initialInputState();
    }

    handleSSN(event) {
        this.setState({
            search: event.target.value
        })
        let onlyLookup = true;

        if (kennitala.isValid(event.target.value)) {
            this.props.dispatch(fetchNationalRegistry(kennitala.clean(event.target.value), onlyLookup))
        }
    }

    clearModal(){
        setTimeout(() => {
            delete this.state.payerObj;
            this.setState({
                ...this.state,
                search: '',
            });
        }, 500)
    }

    getCurrentGenderIndex(gender) {
        let genderValue = "0"
        switch (parseInt(gender)) {
            case 0:
                // male
                genderValue = "1"
                break;
            case 1:
                // female
                genderValue = "2"
                break;
            case 2:
                // boy
                genderValue = "1"
                break;
            case 3:
                // girl
                genderValue = "2"
                break;
        }
        return genderValue;
    }


    addInsuranceTaker() {
        let insuranceTaker = this.props.nationalRegistry.data.find(item => item.OrgId === this.state.search);
        this.props.dispatch(setInfoKey({ key: this.props.fieldName, value: insuranceTaker.OrgId }, this.props.customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Gender", value: this.getCurrentGenderIndex(insuranceTaker.Gender) }, this.props.customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Name", value: insuranceTaker.Name }, this.props.customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Birthdate", value: formatKennitalaAsDate(insuranceTaker.OrgId) }, this.props.customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Address", value: insuranceTaker.Address }, this.props.customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "Postcode", value: insuranceTaker.Postcode }, this.props.customerId));
        this.props.dispatch(setInfoKey({ key: this.props.fieldName + "City", value: insuranceTaker.City }, this.props.customerId));

        this.props.dispatch(addInsuranceTakerFromNationalRegistry(insuranceTaker));
    }

    isDisabled () {
        if (this.state.payerObj === undefined) {
            return true
        }
        let info = kennitala.info(this.state.payerObj.OrgId)
        if (info && info.age < 18) {
            return true
        }
        return false
    }

    render() {

        let age = -1
        if (this.state.payerObj) {
            age = kennitala.info(this.state.payerObj.OrgId).age
        }

        return (


            <div className="modal payer-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className={this.state.payerObj && this.state.payerObj.OrgId ? "payer-form ssn-confirm" : "payer-form"} id="payer-form">
                                <div className="row">
                                    <div className="form-group">
                                        <input id="quote-ssn" className="form-control" placeholder="Kennitala" value={this.state.search} type="text" onChange={this.handleSSN.bind(this)} autoFocus />
                                        {/* <label htmlFor="quote-ssn">Kennitala</label> */}
                                    </div>
                                    <div className="name-container">
                                        {this.state.payerObj && <div className="name">{this.state.payerObj.Name}</div>}
                                        { age !== -1 && age < 18 &&
                                            <Alert variant="warning">
                                                Tryggingataki verður að hafa náð 18 ára aldri
                                            </Alert>
                                        }
                                    </div>
                                </div>
                                <button disabled={this.isDisabled()} className="btn btn-primary" type="button" onClick={this.addInsuranceTaker} data-dismiss="modal">Vista tryggingartaka</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

InsuranceTakerModal.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        nationalRegistry: {},
    }

    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry

    return f;
}

export default connect(mapStateToProps)(InsuranceTakerModal);